import { Select, Spin } from 'antd';
// import type { SelectProps } from 'antd/es/select';
import debounce from 'lodash/debounce';
import React, { useMemo, useRef, useState, useEffect } from 'react';

/**
 * usage
// 回调值

value:
        [
            {
                disabled: undefined
                key: 570830525
                label: "18812068977(皖)"
                   value: 570830525
            }
        ]
const [value, setValue] = useState([]);
// 请求
async function fetchUserList(username) {
    return searchUserList({
        requestData: { search: username },
        page: {
            currentPage: 1,
            pageSize: 10,
        },
    }).then((body) =>
        body.data.map((user) => {
            let nick = user.nickName ? "(" + user.nickName + ")" : "";
            // options 固定结构
            return ({
                label: user.phone + nick,
                value: user.userId,
            })
        }),
    );
}
<DebounceSelect
    disabled={editRecord}
    mode="multiple"
    value={value}
    placeholder="请选择用户!"
    fetchOptions={fetchUserList}
    onChange={(newValue) => {
        setValue(newValue);
    }}
    style={{
        width: '100%',
    }}
/>
*/

/**
 *  有远程搜索，防抖控制，请求时序控制
 *  https://ant.design/components/select-cn/#header
 *
 * @param fetchOptions 远端请求
 * @param debounceTimeout 防抖时间 默认 800
 * @param props Select 参数
 * @returns
 */

const DebounceSelect = ({
  fetchOptions,
  debounceTimeout = 800,
  defaultOptions,
  ...props
}) => {
  useEffect(() => {
    setOptions(defaultOptions);
  }, [defaultOptions]);

  const [fetching, setFetching] = useState(false);
  const [options, setOptions] = useState(defaultOptions || []);
  const fetchRef = useRef(0);
  const debounceFetcher = useMemo(() => {
    const loadOptions = (value) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;
      setOptions([]);
      setFetching(true);
      fetchOptions(value).then((newOptions) => {
        if (fetchId !== fetchRef.current) {
          // for fetch callback order
          return;
        }
        setOptions(newOptions);
        setFetching(false);
      });
    };

    return debounce(loadOptions, debounceTimeout);
  }, [fetchOptions, debounceTimeout]);
  return (
    <Select
      labelInValue={props?.labelInValue || true}
      filterOption={false}
      onSearch={debounceFetcher}
      notFoundContent={fetching ? <Spin size="small" /> : null}
      {...props}
      options={options}
    />
  );
};

export default DebounceSelect;
